module.exports = __webpack_public_path__ + "static/media/carynIcon.4299e45c.jpg";